import { useIntl } from '@weenat/wintl';
import moment from 'moment-timezone';
import { useMemo } from 'react';
import { useClient } from '../../../ClientProvider';
import useMutation from '../../../useMutation';
import useQuery from '../../../useQuery';
/** @deprecated */
export const useDecitraitTreatmentItem = ({ treatment, orgId, onDeleteTreatmentSuccess }) => {
    const { t } = useIntl();
    const client = useClient();
    // TODO: handle rollback when it fail
    const [deleteTreatment] = useMutation(client.decitrait.deleteTreatment({ treatmentId: treatment.id, orgId }), { onSuccess: onDeleteTreatmentSuccess });
    const productsRequest = useQuery(client.decitrait.products({ organizationId: orgId }));
    const products = productsRequest.data;
    const treatmentProducts = useMemo(() => products
        ? treatment.products.map((x) => {
            return {
                ...(products[x.diseaseId]
                    ? // We may get junk data from decitrait, hence the check just before
                        products[x.diseaseId].find((y) => {
                            return y.id === x.productId;
                        })
                    : {}),
                ...x
            };
        })
        : [], [products]);
    return {
        productsRequest,
        treatmentProducts,
        props: {
            discardable: {
                onDiscard: () => deleteTreatment(),
                title: moment(treatment.treatmentDate).format(t(`formats.date`))
            }
        }
    };
};
